export const CURP_RE = /^[A-Z][AEIOUX][A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HMX](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d]\d$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const CP_RE = /^\d{5}$/;
export const PHONE_RE = /^\d{10}$/;
export const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
export const MAX_FILE_MB = 5;

export const onlyDigits = (v, max) => v.replace(/\D/g, '').slice(0, max);
export const cleanCurp = (v) => v.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18);

export const fileError = (f) => {
  if (!f) return 'Este documento es obligatorio.';
  if (!ALLOWED_TYPES.includes(f.type)) return 'Formato no permitido. Usa JPG, PNG o PDF.';
  if (f.size > MAX_FILE_MB * 1024 * 1024) return `El archivo supera ${MAX_FILE_MB} MB.`;
  return '';
};

export const MESSAGES = {
  required: 'Este campo es obligatorio.',
  curp: 'La CURP debe tener 18 caracteres con el formato oficial.',
  cp: 'El C.P. debe tener exactamente 5 dígitos.',
  phone: 'El celular debe tener 10 dígitos.',
  email: 'Ingresa un correo electrónico válido.',
};
